import { Injectable, inject } from '@angular/core';
import { ApiService } from './api.service';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class DownloadService {
  private api = inject(ApiService);

  getAll() { return this.api.get('/download_files'); }

  async download(id: number, fileName: string): Promise<void> {
    const http = this.api.getHttp();
    const blob = await firstValueFrom(
      http.get(`${environment.apiBaseUrl}/download_files/${id}`, { responseType: 'blob' })
    );
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  }
}
